<div class="modal-header">
  <h3 class="modal-title" i18n="@@TicketConditions">Ticket Conditions</h3>
  <button
    type="button"
    class="light-icon-button close"
    aria-label="Close Ticket Conditions Modal"
    (click)="close()"
    ngbAutoFocus
  >
    <i class="ico-cancel AA-standard-grey" aria-hidden="true"></i>
  </button>
</div>
<div class="modal-body" tabindex="0">
  @if (ticketIsObject && ticketDetails) {
    <dl class="modal-list">
      @for (detail of ticketConditionsOrdered; track detail) {
        @if (detail.value) {
          <div
            class="modal-list-item"
            [ngClass]="{ 'ticket-name': detail.key === 'ticketTypeName' }"
          >
            <dt class="rule-title">{{ detail.key | translate | titlecase }}</dt>
            <dd class="rule-value" [innerHTML]="detail.value"></dd>
          </div>
        }
      }

      @if (includedExtras?.length) {
        <div class="modal-list-item">
          <dt class="rule-title" i18n="@@trainlineFreeExtras">Free extras</dt>
          <dd class="rule-value">
            @for (extras of includedExtras; track extras) {
              <div>{{ extras }}</div>
            }
          </dd>
        </div>
      }
    </dl>
  } @else if (ticketDetails) {
    <dl class="modal-list">
      @for (detail of ticketDetails; track detail) {
        @if (detail.value) {
          <div
            class="modal-list-item"
            [ngClass]="{ 'ticket-name': detail.key === 'ticketTypeName' }"
          >
            <dt class="rule-title">{{ detail.key | translate | titlecase }}</dt>
            <dd class="rule-value" [innerHTML]="detail.value"></dd>
          </div>
        }
      }

      @if (includedExtras?.length) {
        <div class="modal-list-item">
          <dt class="rule-title" i18n="@@trainlineFreeExtras">Free extras</dt>
          <dd class="rule-value">
            @for (extras of includedExtras; track extras) {
              <div>{{ extras }}</div>
            }
          </dd>
        </div>
      }
    </dl>
  } @else {
    <span>No data to display</span>
  }
</div>
<div class="modal-footer">
  <button type="button" title="Ok" appButton="small" (click)="close()">Ok</button>
</div>
